@if(incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup" (change)="saveForm()">

    <snelstart-ui-number-form-control
      formControlName="arbeidsInkomenPartner"
      id="arbeidsInkomenPartner"
      class="custom-input-250"
      [decimals]="0"
      align="right"
      prefix="€"
      label="Arbeidsinkomen partner"
    >
    </snelstart-ui-number-form-control>

    <snelstart-ui-number-form-control
      formControlName="verzamelInkomenPartner"
      id="verzamelInkomenPartner"
      class="custom-input-250"
      [decimals]="0"
      align="right"
      prefix="€"
      label="Verzamelinkomen partner"
    >
    </snelstart-ui-number-form-control>
  </form>
}
